<script>
  import Icon from "svelte-awesome";
  import { Badge, Spinner } from "sveltestrap";
  import { tasks, comment } from "svelte-awesome/icons";
  import EditJobsModal from "../EditJobsModal.svelte";
  import FloorListContainer from "./FloorListContainer.svelte";
  import { onMount } from "svelte";
  import axios from "axios";
  import { format as formatDate } from 'date-fns';

  export let jobDetail = {};
  export let deliverableItemId;
  export let deliverableItemSequenceNo = 0;

  const PRIORITY_LOW = 100000000;
  const PRIORITY_MED = 100000001;
  const PRIORITY_HI = 100000002;
  const FLOOR_COMPLETED = 100000004;

  let shownSection = '';

  let isFetchingContacts = false;
  let isFetchingFloors = false;
  let isFloorFetched = false;

  let editJobsModal = {};

  let floors = [];
  let resources = [];

  let isInView = false;
  let isCollapsed = true;

  onMount(() => {
    getLoadResources(document.querySelector(`.resource-container-${jobDetail.DeliverableId}`));
  });

  function getLoadResources(container) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          isInView = true;
          getResources();
          observer.disconnect();
        }
      })
    });

    observer.observe(container);
  }

  function openJobFormModal() {
    editJobsModal.openModal(deliverableItemId, jobDetail.JobId, jobDetail);
  }

  function GetAcronym(string) {
    var matches = string.match(/\b(\w)/g); // ['J','S','O','N']
    return matches.join("").toUpperCase();
  }

  function onFloorChanged() {
    isFloorFetched = false;
    if (shownSection === 'floors') {
      getFloorStatusSummary();
    }
  }

  function toggleFloors() {
    shownSection = shownSection !== 'floors' ? 'floors' : '';
    if (shownSection === 'floors' && !isFetchingFloors && !isFloorFetched && floors.length <= 0) {
      getFloorStatusSummary();
    }
  }

  function getFloorStatusSummary() {
    isFetchingFloors = true;
    axios.get(`/jobboardapi/GetFloorStatusSummary?jobId=${jobDetail.JobId}` +
      `&deliverableId=${jobDetail.DeliverableId}` +
      `&propertyId=${jobDetail.PropertyId}`)
      .then(res => {
        floors = res.data || [];
        isFetchingFloors = false;
        isFloorFetched = true;
      })
      .catch(console.warn);
  }

  function getResources() {
    isFetchingContacts = true;
    axios.get(`/resourceapi/retrieveallresourceassigned?deliverableId=${jobDetail.DeliverableId}`)
      .then(res => {
        resources = res.data || [];
      })
      .catch(console.warn)
      .finally(_ => isFetchingContacts = false);
  }

  function toggleContent() {
    isCollapsed = !isCollapsed;
  }

</script>

<style>
  .deliverable-jobs-card {
    margin: 1px 0px;
    padding: 10px;
    /* border: 1px solid grey; */
    background-color: white;
    /* border-radius: 5px; */
    word-wrap: break-word;
  }
  .information-row {
    margin: 10px 0px;
    display: flex;
  }
  .information-row p {
    font-size: 12px;
    margin: 0;
  }
  .information-row button {
    margin: 0 auto;
    border-radius: 50%;
    border: none;
  }
  .start-date {
    display: block;
  }
  .end-date {
    margin: 0 auto;
  }
  .btn-job {
    margin: 0 auto;
    background-color: transparent;
    border: 1px solid #fff;
    outline-color: #fff;
    font-weight: 500;
    font-size: 12px;
  }
  .btn-job:hover {
    border-bottom: 1px solid #2980b9;
    color: #2980b9;
  }

  .compact.deliverable-jobs-card {
    margin: 0px;
    padding: 0px;
    border: 5px solid #dcdde1;
  }

  .compact.deliverable-jobs-card > hr:first-of-type {
    margin: 0px;
  }

  .compact.deliverable-jobs-card .information-row {
    padding: 0px 10px;
  }

  .compact.deliverable-jobs-card .btn-job {
    border: none;
    padding: 0px;
    min-height: 40px;
    max-height: 40px;
  }

  .compact.deliverable-jobs-card .btn-collapse-content {
    padding: 0px;
    height: 1rem;
  }

  .compact.deliverable-jobs-card div[class^=resource-container-] h5 {
    margin-top: 0px;
  }

  @media (max-width: 768px) {
    .deliverable-jobs-card {
      /*width: 48%;*/
      vertical-align: top;
      border: 1px solid #ced4da;
      border-radius: 0;
      margin-right: 3px;
      display: inline-block;
      font-size: 12px;
      margin-bottom: 5px;
      padding: 5px;
    }
    .deliverable-jobs-card hr {
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .deliverable-jobs-card p {
      margin-bottom: 5px;
    }
    .deliverable-header {
      border: 1px solid #ced4da;
      min-height: 30px;
    }
    .information-row {
      margin: 5px;
    }
  }
</style>

<div class="deliverable-jobs-card compact">
  {#if jobDetail.IsBuildingUpdate}
    <p>Building Update</p>
  {/if}
  <center>
    <button class="btn-job" on:click={openJobFormModal}>
      {jobDetail.JobName}
    </button>
  </center>
  <hr />
  <button class="btn btn-sm btn-block btn-collapse-content" on:click={toggleContent}>
    <span class="fa fa-chevron-{isCollapsed ? 'down' : 'up'}"></span>
  </button>
  {#if !isCollapsed}
    <div class="information-row">
      <center>
        <p>Job Due Date: {formatDate(new Date(jobDetail.JobDueDate), 'MM/dd/yyyy')}</p>
      </center>
    </div>
    <hr />
    <div class="information-row">
      <div>
        <p>Job Summary:</p>
        <p>{jobDetail.JobPhaseSummary}</p>
      </div>
    </div>
    <hr />
    <div class="information-row">
      {#if !!jobDetail.MeasurementStandard1}
        <div>
          <p>Measurement Standard 1:</p>
          <p>{jobDetail.MeasurementStandard1}</p>
        </div>
      {/if}
      {#if !!jobDetail.MeasurementStandard2}
        <div>
          <p>Measurement Standard 2:</p>
          <p>{jobDetail.MeasurementStandard2}</p>
        </div>
      {/if}
      {#if !!jobDetail.MeasurementStandard3}
        <div>
          <p>Measurement Standard 3:</p>
          <p>{jobDetail.MeasurementStandard3}</p>
        </div>
      {/if}
      {#if !!jobDetail.MeasurementStandard4}
        <div>
          <p>Measurement Standard 4:</p>
          <p>{jobDetail.MeasurementStandard4}</p>
        </div>
      {/if}
    </div>
    <hr />
    <div class="information-row">
      {#if !!jobDetail.PriorityId}
        <button on:click={() => (shownSection = shownSection !== 'priority' ? 'priority' : '')}>
          {#if jobDetail.PriorityId === PRIORITY_LOW}
            LOW
          {:else if jobDetail.PriorityId === PRIORITY_MED}
            MED
          {:else if jobDetail.PriorityId === PRIORITY_HI}
            HI
          {/if}
        </button>
      {/if}
      {#if !!jobDetail.ProjectNotes}
        <button style="background-color: #e67e22; color: white;"
          on:click={() => shownSection = shownSection !== 'notes' ? 'notes' : ''}>
          <Icon data={comment} />
        </button>
      {/if}
      <button style="background-color: #34495e; color: white"
        on:click={toggleFloors}>
        <Icon data={tasks} />
      </button>
    </div>
  {/if}
  <div class="resource-container-{jobDetail.DeliverableId}">
    <h5>
      {#if !!jobDetail.ProjectManagerName}
        <Badge pill style="margin: 5px" color="success">
          {GetAcronym(jobDetail.ProjectManagerName)} - PM
        </Badge>
      {/if}
      {#if isInView}
        {#if isFetchingContacts}
          <span>
            <Spinner type="grow" size="sm" style="margin: auto;" />
            <Spinner type="grow" size="sm" style="margin: auto;" />
            <Spinner type="grow" size="sm" style="margin: auto;" />
          </span>
        {:else if resources.length > 0}
          {#each resources as resource}
            <Badge pill style="margin: 5px" color="info">
              {GetAcronym(resource.FullName)}
            </Badge>
          {/each}
        {:else}
          <small><i>No Resource</i></small>
        {/if}
      {/if}
    </h5>
  </div>
  {#if shownSection === 'priority'}
    <hr />
    <p>
      Priority:
      {#if jobDetail.PriorityId === PRIORITY_LOW}
        Low
      {:else if jobDetail.PriorityId === PRIORITY_MED}
        Medium
      {:else if jobDetail.PriorityId === PRIORITY_HI}
        High
      {/if}
    </p>
  {:else if shownSection === 'notes'}
    <hr />
    <p>{jobDetail.ProjectNotes}</p>
  {:else if shownSection === 'floors'}
    <hr />
    {#if isFetchingFloors}
      <center>
        <Spinner type="grow" size="sm" style="margin: auto;" />
        <Spinner type="grow" size="sm" style="margin: auto;" />
        <Spinner type="grow" size="sm" style="margin: auto;" />
      </center>
    {:else}
      {#if floors.length <= 0}
        <i>
          <center>No Floors</center>
        </i>
      {:else}
        <ul class="floor-list">
          {#each floors as floor}
            {#if floor.StatusId === FLOOR_COMPLETED}
              <li style="text-decoration: line-through">
                {floor.FloorName}
              </li>
            {:else}
              <li>{floor.FloorName}</li>
            {/if}
          {/each}
        </ul>
      {/if}
    {/if}
  {/if}
</div>
<EditJobsModal
  bind:this={editJobsModal}
  {deliverableItemSequenceNo}
  on:floorChanged={onFloorChanged}
  on:jobUpdated />
